/* ss-header.js — cassetto del menu */
(function () {
  var open = document.querySelector('[data-ss-open]');
  var drawer = document.getElementById('ss-drawer');
  if (!open || !drawer) return;
  // il cassetto vive in fondo al body: dentro l'intestazione, se un antenato ha
  // una trasformazione, position:fixed si aggancia a quello e non allo schermo
  if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  var last = null;

  function show() {
    last = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    open.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }
  function hide() {
    drawer.classList.remove('is-open');
    open.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (last) last.focus();
  }
  open.addEventListener('click', show);
  [].forEach.call(drawer.querySelectorAll('[data-ss-close]'), function (b) {
    b.addEventListener('click', hide);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) hide();
  });
})();

/* la barra annuncio alterna i messaggi */
(function () {
  var box = document.querySelector('[data-ss-promo]');
  if (!box) return;
  var msgs = [].slice.call(box.children);
  /* i numeri e gli importi vanno in grassetto da soli: chi scrive l'annuncio
     nell'editor mette solo il testo, senza doversi ricordare del markup */
  msgs.forEach(function (m) {
    m.innerHTML = m.textContent.replace(/(\d+(?:[.,]\d+)?\s*(?:%|€))/g, '<b>$1</b>');
  });
  if (msgs.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var i = 0;
  setInterval(function () {
    msgs[i].hidden = true;
    i = (i + 1) % msgs.length;
    msgs[i].hidden = false;
    msgs[i].style.animation = 'none';
    void msgs[i].offsetWidth;
    msgs[i].style.animation = '';
  }, 4500);
})();
